import envConfig from '../../static/config';
import FraudAndDisputeActionCreator from '../actions/FraudAndDisputeActionCreator';
import { POST_API_METHOD } from '../constants/FraudAndDisputeConstants';
import UserManagementStore from '../stores/UserManagementStore';
import ApiUtils from './ApiUtils';
import config from '../config';

class FraudAndDisputeApiUtils {
  static submitDisputeCase(requestData) {
    const user = UserManagementStore.getCADetails();
    const customerId = user?.customers?.[0].customer_id;
    const submitDisputeCaseEndpoint =
      '/ibapi/v2/banks/{bank-id}/customer/{customerId}/claims/dispute';
    const url = `${
      envConfig.apiBaseUrlAzure
    }${submitDisputeCaseEndpoint.replace('{customerId}', customerId)}`;

    ApiUtils.makeAjaxCall(
      {
        /**
         * API version is not mandatory for Azure apis.
         * Adding default version here since this is a mandatory field in our method.
         */
        apiVersion: config.apiVersions.submitDisputeService,
        method: POST_API_METHOD,
        url,
        requestData,
        addAuthToken: true,
      },
      (body) => {
        FraudAndDisputeActionCreator.handleSubmitDisputeCaseSuccess(body);
      },
      (error, status) => {
        FraudAndDisputeActionCreator.handleSubmitDisputeCaseFailure(
          error,
          status
        );
      }
    );
  }
}

export default FraudAndDisputeApiUtils;
